import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SeoHead from '@/components/base/SeoHead';

const faqItems = [
  {
    q: '97影院需要注册吗？',
    a: '97影院完全免费，无需注册即可在线观看所有电视剧资源。我们致力于为用户提供最便捷的观影体验。',
  },
  {
    q: '97影院的画质如何？',
    a: '97影院提供高清蓝光画质，支持流畅播放不卡顿。我们采用先进的视频压缩和CDN加速技术，确保用户在任何网络环境下都能获得良好的观影体验。',
  },
  {
    q: '97影院更新速度快吗？',
    a: '97影院与各大视频平台同步更新，最新剧集上线后第一时间更新。国产剧、韩剧、美剧等热门剧集更新速度在行业内领先。',
  },
  {
    q: '97影院支持哪些设备观看？',
    a: '97影院支持PC电脑、平板、手机等多种设备在线观看，自适应不同屏幕尺寸，随时随地畅享追剧乐趣。',
  },
  {
    q: '97影院的资源是否正版？',
    a: '97影院的资源均来源于互联网公开分享，仅供学习交流之用。我们尊重知识产权，如涉及版权问题请及时联系我们处理。',
  },
];

const testimonials = [
  {
    name: '追剧达人小王',
    content: '97影院真的是我看过最好用的免费影视网站了！更新速度超快，画质清晰流畅，已经推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    name: '电视剧爱好者李姐',
    content: '用了97影院快一年了，资源丰富，分类清晰，国产剧韩剧美剧应有尽有。最重要的是完全免费，真的良心平台！',
    rating: 5,
  },
  {
    name: '资深剧迷老张',
    content: '对比了很多同类网站，97影院的体验是最好的。界面简洁大气，没有烦人的弹窗广告，追剧体验一级棒。',
    rating: 5,
  },
  {
    name: '学生党小陈',
    content: '作为学生党，免费看高清电视剧真的太香了。97影院的蓝光画质完全不输付费平台，而且很多冷门剧也能找到。',
    rating: 4,
  },
  {
    name: '全职妈妈阿芳',
    content: '在家带娃的闲暇时间全靠97影院打发，剧集更新及时，分类也很全。手机上看也很流畅，不卡顿。',
    rating: 5,
  },
  {
    name: '上班族刘先生',
    content: '下班回家就想看剧放松，97影院资源全、更新快、画质好，已经成为我每天必打开的网站了。强烈推荐！',
    rating: 5,
  },
];

export default function About() {
  const aboutSeoTitle = '关于97影院 - 品牌介绍与联系方式 - 97影院';
  const aboutSeoDesc = '97影院提供电视剧全集在线观看服务，热门国产剧、韩剧、美剧全集免费看。品牌介绍、用户口碑、联系方式尽在97影院关于我们页面。';
  const aboutSeoKeywords = '97影院,关于97影院,97影院品牌,影视网站,免费在线观看,高清蓝光,联系我们';

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '97影院',
    url: 'https://97yingyuan.com',
    description: '高清蓝光不卡顿，热门电视剧全集免费在线观看平台',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@97yingyuan.com',
      availableLanguage: ['Chinese'],
    },
  };

  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于97影院',
    description: aboutSeoDesc,
    url: 'https://97yingyuan.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '97影院',
      url: 'https://97yingyuan.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <SeoHead
        title={aboutSeoTitle}
        description={aboutSeoDesc}
        keywords={aboutSeoKeywords}
        canonicalUrl="https://97yingyuan.com/about"
        schemaData={aboutPageSchema}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema, null, 2) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema, null, 2) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6 py-8">
            <div className="max-w-4xl mx-auto">
              <div className="mb-6">
                <Breadcrumb
                  items={[
                    { label: '首页', href: '/' },
                    { label: '关于我们' },
                  ]}
                />
              </div>

              <section className="mb-12">
                <div className="text-center mb-8">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-500/20">
                    <div className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-xl">
                      <span className="text-white font-heading font-bold text-lg">97</span>
                    </div>
                  </div>
                  <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                    关于97影院
                  </h1>
                  <p className="text-foreground-400 max-w-lg mx-auto text-sm leading-relaxed">
                    致力于为广大影视爱好者提供高清、流畅、免费的在线观影体验
                  </p>
                </div>

                <div className="bg-background-100 rounded-2xl p-6 md:p-8 mb-8">
                  <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">
                    品牌介绍
                  </h2>
                  <div className="text-foreground-500 text-sm leading-relaxed space-y-4">
                    <p>
                      97影院成立于2020年，是国内领先的免费在线影视观看平台。我们专注于提供<strong className="text-foreground-700">高清蓝光画质</strong>和<strong className="text-foreground-700">流畅不卡顿</strong>的观影体验，涵盖国产剧、韩剧、美剧、日剧、泰剧、动漫等丰富的影视资源。
                    </p>
                    <p>
                      97影院的核心理念是<strong className="text-foreground-700">让每个人都能够免费享受高品质的影视内容</strong>。我们通过先进的技术架构和优化的播放系统，确保用户在PC、平板、手机等多终端设备上都能获得流畅的观影体验。
                    </p>
                    <p>
                      经过多年的发展，97影院已经积累了海量的影视资源和庞大的用户群体。我们的影视库每日更新，与各大平台保持同步，确保用户能够在第一时间观看到最新的电视剧集。无论是最新上线的国产热剧，还是经典韩剧美剧，在97影院都能找到。
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-500/20">
                      <i className="ri-movie-2-line text-xl text-primary-500"></i>
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1">10000+</h3>
                    <p className="text-foreground-400 text-sm">影视资源</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-500/20">
                      <i className="ri-user-heart-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1">500万+</h3>
                    <p className="text-foreground-400 text-sm">活跃用户</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-500/20">
                      <i className="ri-shield-check-line text-xl text-secondary-500"></i>
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground-900 mb-1">4K蓝光</h3>
                    <p className="text-foreground-400 text-sm">高清画质</p>
                  </div>
                </div>
              </section>

              <section className="mb-12">
                <div className="text-center mb-8">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                    用户口碑
                  </h2>
                  <p className="text-foreground-400 text-sm">听听我们的用户怎么说</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {testimonials.map((item, index) => (
                    <div key={index} className="bg-background-100 rounded-xl p-5">
                      <div className="flex items-center gap-1 mb-3">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`text-xs ${i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-fill text-foreground-200'}`}
                          ></i>
                        ))}
                      </div>
                      <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                        &ldquo;{item.content}&rdquo;
                      </p>
                      <p className="text-foreground-700 text-sm font-medium">{item.name}</p>
                    </div>
                  ))}
                </div>
              </section>

              <section className="mb-12">
                <div className="text-center mb-8">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                    常见问题
                  </h2>
                  <p className="text-foreground-400 text-sm">关于97影院的常见疑问解答</p>
                </div>
                <div className="space-y-3">
                  {faqItems.map((item, index) => (
                    <details key={index} className="group bg-background-100 rounded-xl overflow-hidden">
                      <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800 hover:text-foreground-950 transition-colors">
                        {item.q}
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                      </summary>
                      <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                        {item.a}
                      </div>
                    </details>
                  ))}
                </div>
              </section>

              <section>
                <div className="text-center mb-8">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                    联系我们
                  </h2>
                  <p className="text-foreground-400 text-sm">如有任何问题或建议，欢迎通过以下方式联系我们</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-500/20">
                      <i className="ri-mail-line text-xl text-primary-500"></i>
                    </div>
                    <h3 className="text-foreground-900 font-semibold text-sm mb-1">电子邮箱</h3>
                    <p className="text-foreground-400 text-sm">contact@97yingyuan.com</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-500/20">
                      <i className="ri-wechat-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-foreground-900 font-semibold text-sm mb-1">微信公众号</h3>
                    <p className="text-foreground-400 text-sm">97影院官方</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-500/20">
                      <i className="ri-weibo-line text-xl text-secondary-500"></i>
                    </div>
                    <h3 className="text-foreground-900 font-semibold text-sm mb-1">官方微博</h3>
                    <p className="text-foreground-400 text-sm">@97影院官方微博</p>
                  </div>
                </div>

                <div className="bg-background-100 rounded-2xl p-6 md:p-8 mt-6 text-center">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                    版权声明
                  </h3>
                  <p className="text-foreground-400 text-sm leading-relaxed max-w-2xl mx-auto">
                    97影院所有视频资源均来源于互联网公开分享链接，仅供网友学习交流之用。本站不存储、不制作任何视频内容。
                    如您认为本站所展示的内容侵犯了您的合法权益，请通过上述联系方式与我们取得联系，我们将在第一时间核实并处理。
                    感谢您的理解与支持。
                  </p>
                </div>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}